"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

var H5 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H5",
  componentId: "sc-1rz0byb-0"
})([""]);
H5.propTypes = _Heading.default.propTypes;
H5.defaultProps = Object.assign({}, _Heading.default.defaultProps, {
  tagName: 'h5'
});
H5.displayName = 'H5';
var _default = H5;
exports.default = _default;
module.exports = exports.default;